import { UTFooter } from '@group-link-one/gl-ui/utilities';
import clsx from 'clsx';
import { ChildContent } from '../ChildContent/ChildContent';
import S from '../Main.template.style';
import type { IMainContent } from './types/MainContent.types';
import { useMainContent } from './useMainContent';

const MainContent = ({
  topTitle,
  children,
  topAddon,
  id,
  timeoutDetailed,
  detailedChildren,
  justChildContent,
  styling,
  is100PercentJustChildContent,
  isDetailsOpenned,
  isSticked = false,
  hasOverflowWhenDetailedChildrenOpen = true,
  childContTopAlign,
}: IMainContent) => {
  const { refContent, refWrapperContentDetailed, footerText } = useMainContent({
    isDetailsOpenned,
    timeoutDetailed,
    justChildContent,
    is100PercentJustChildContent,
  });

  return (
    <S.Content
      ref={refContent}
      id={id}
      className={clsx(
        isDetailsOpenned ? 'is-details-opened' : '',
        justChildContent ? 'just-child-content' : '',
        hasOverflowWhenDetailedChildrenOpen ? 'has-overflow-when-detailed-children-open' : '',
      )}
    >
      <S.WrapperContent
        className={`gl-wrapper-content ${justChildContent ? 'just-child-content' : ''}`}
        styling={styling}
      >
        <ChildContent
          topTitle={topTitle}
          topAddon={topAddon}
          justChildContent={justChildContent}
          id={id}
          isSticked={isSticked}
          childContTopAlign={childContTopAlign}
        >
          {children}
        </ChildContent>

        {!justChildContent && <UTFooter text={footerText} />}
      </S.WrapperContent>

      <S.WrapperContent
        ref={refWrapperContentDetailed}
        className={`gl-wrapper-content-detailed ${justChildContent ? 'just-child-content' : ''}`}
      >
        {detailedChildren}
      </S.WrapperContent>
    </S.Content>
  );
};

export { MainContent };
